import { catchError, map, retry } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NavigationConstant } from '../constant/navigation.constant';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultComponent } from '../component/modal/result/result.component';
import { ResponseCodeConstant } from '../constant/response-code.constant';
import { MessageConstant } from '../constant/message.constant';
import {JwtHelperService} from '@auth0/angular-jwt';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
export class RequestHelper {
  private contentPathURL: string;
  private bodyJSON: any;
  private pathParameters: Map<string, string>;

  constructor(
    private router: Router,
    private http: HttpClient,
    private modalService: NgbModal
  ) { }

  get(path): Observable<any> {
    return this.http.get(path, httpOptions).pipe(catchError(this.errorHandler));
  }

  post(path, parameters): Observable<any> {
    return this.http.post(path, parameters, httpOptions).pipe(
      map((response) => this.responseHandler(response)),
      catchError(this.errorHandler));
  }

  home() {
    this.router.navigate([NavigationConstant.HOME]);
  }

  openDialog(result, redirectTo = NavigationConstant.HOME) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    const modalRef = this.modalService.open(ResultComponent, ngbModalOptions);
    modalRef.componentInstance.state = result;
    modalRef.componentInstance.redirectTo = redirectTo;
  }

  responseHandler(response) {
    if (response.responseCode === ResponseCodeConstant.INTERNAL_SERVER_ERROR) {
      this.openDialog(MessageConstant.CANNOT_PROCESS);
      throw response;
     }
    return response;
  }

  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.responseCode}\nMessage: ${error.responseMessage}`;
    }
    this.openDialog(MessageConstant.CANNOT_PROCESS);
    return throwError(errorMessage);
  }

  decodeToken(token) {
    const helper = new JwtHelperService();
    return helper.decodeToken(token);
  }
}
